import React from "react";
import { useTranslation } from "react-i18next";

import "./OrderConfirmation.scss";

const OrderLoading: React.FC = () => {
	const { t } = useTranslation();

	return (
		<div className="OrderConfirmationPage">
			<div className="OrderConfirmationContent">
				<div className="LoadingMessage">
					<h1>{t("orderConfirmation.loading")}</h1>
					<p>{t("orderConfirmation.loadingMessage")}</p>
				</div>
			</div>
		</div>
	);
};

export default OrderLoading;
